import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

import Icon from '../Icon/Icon';

const header = ( props ) => (
	<header id="Header" className={ props.className }>
		<Link to="/">
			<Icon icon="logo" title="IDSI Logo" />
		</Link>
	</header>
);

export default header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js